import { useCallback, useEffect, useState } from "react"
import { type EdizioneInElenco, type StatoRegia, apiRegia } from "../../api/regia"
import { useLargo } from "../../stato/useLargo"

interface Props {
  /** `null` alla primissima installazione: non esiste ancora nessuna annata,
   *  ed è proprio da qui che si crea la prima. */
  stato: StatoRegia | null
  codice: string
  onVaiA: (serataId: string) => void
  comando: (azione: () => Promise<unknown>) => Promise<void>
}

/** Un'edizione per anno. L'app si riusa ogni febbraio; artisti e giurati no. */
export function Edizioni({ stato, codice, onVaiA, comando }: Props) {
  const [elenco, setElenco] = useState<EdizioneInElenco[]>([])
  const [anno, setAnno] = useState(new Date().getFullYear() + 1)
  const [serate, setSerate] = useState(5)
  const [esito, setEsito] = useState<string | null>(null)
  const largo = useLargo()

  const carica = useCallback(async () => {
    setElenco((await apiRegia.edizioni(codice)).edizioni)
  }, [codice])

  useEffect(() => {
    void carica()
  }, [carica])

  async function crea(ev: React.FormEvent) {
    ev.preventDefault()
    await comando(async () => {
      await apiRegia.creaEdizione(codice, { year: anno, n_serate: serate })
      setEsito(`Edizione ${anno} creata. Il link per gli amici è nella scheda Gruppo.`)
      await carica()
    })
  }

  return (
    <section className="edizioni">
      <div className="edizioni__archivio">
        <p className="occhiello">Edizioni</p>
        {elenco.length === 0 && (
          <p className="regia__vuoto">
            Non c'è ancora nessuna edizione. Creane una {largo ? "qui accanto" : "qui sotto"}:
            nasce vuota, e gli artisti si aggiungono quando esce la lista dei Big.
          </p>
        )}
        <ul className="edizioni__elenco">
          {elenco.map((e) => (
            <li key={e.id}>
              <button
                type="button"
                className="edizioni__voce"
                aria-current={e.id === stato?.edizione.id}
                disabled={e.serate.length === 0}
                onClick={() => onVaiA(e.serate[0].id)}
              >
                <span className="edizioni__anno">{e.year}</span>
                <span className="regia__nome">
                  {e.name}
                  <small>
                    {e.artisti} artisti · {e.giurati} giurati
                  </small>
                </span>
                <span className="regia__stato">{e.status}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="edizioni__laterale">
        <form className="scheda edizioni__nuova" onSubmit={crea}>
          <p className="occhiello">Nuova edizione</p>
          <div className="edizioni__riga">
            <label className="edizioni__campo">
              Anno
              <input
                className="campo"
                type="number"
                min={1951}
                max={2100}
                value={anno}
                onChange={(e) => setAnno(Number(e.target.value))}
              />
            </label>
            <label className="edizioni__campo">
              Serate
              <input
                className="campo"
                type="number"
                min={1}
                max={10}
                value={serate}
                onChange={(e) => setSerate(Number(e.target.value))}
              />
            </label>
          </div>
          <button className="bottone primario" type="submit">
            Crea l'edizione {anno}
          </button>
          <p className="delicate__nota">
            Nasce senza artisti: la lista dei Big si aggiunge dalla scheda Artisti quando esce.
          </p>
        </form>

        {esito && <p className="artisti__esito">{esito}</p>}
      </div>
    </section>
  )
}
